import { render } from "./ViewFingerspotAttendance.vue?vue&type=template&id=972125b6&scoped=true"
import script from "./ViewFingerspotAttendance.vue?vue&type=script&lang=js"
export * from "./ViewFingerspotAttendance.vue?vue&type=script&lang=js"

import "./fingerspot-attendance.scss?vue&type=style&index=0&id=972125b6&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972125b6"]])

export default __exports__